"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandResult = void 0;
class CommandResult {
    constructor(resultingState) {
        this.resultingState = resultingState;
    }
}
exports.CommandResult = CommandResult;
